<template>
  <v-form ref="form" v-model="isFormValid">
    <v-row no-gutters v-for="(rule, index) in rules" :key="index">
      <v-row no-gutters class="d-flex justify-end mt-12">
        <v-col cols="12">
          <h2 class="ml-3">Rule {{ index + 1 }}</h2>
        </v-col>
        
      </v-row>
      <v-col cols="12">
        <v-row no-gutters class="d-flex justify-space-around ml-3 mt-5">
          <v-col cols="5" class="pr-5">
            <auto-complete
              :selection.sync='rule.ruleSegmentId'
              :apiName="getSegmentApiName"
              :responseName="'segments'"
              :dataList="rule.ruleSegmentId ? 
              [{id: rule.ruleSegmentId, name: rule.ruleSegmentName}] : []"
              label="Segment *"
              :rules="validationRules.ruleSegmentId"
              :sortBy="'desc'"
              :sortValue="'updated_at'"
              :noFolder="true"
            />
          </v-col>
          <v-col cols="5" class="px-3">
            <auto-complete
              :selection.sync='rule.ruleContentFeedId'
              :apiName="getContentFeedApiName"
              :responseName="'content_feeds'"
              label="Content Feed"
              :dataList="rule.ruleContentFeedId ? 
              [{id: rule.ruleContentFeedId, name: rule.ruleContentFeedName}] : []"
              :sortBy="'desc'"
              :sortValue="'updated_at'"
              :noFolder="true"
            />
          </v-col>
          <v-col cols="2" class="mt-4 text-left">
            <v-icon
              title="Delete Rule"
              v-track="'delete-rule'"
              @click="deleteRule(index)"
            >
              mdi-delete
            </v-icon>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="px-3 mb-5">
        <ck-editor 
        :value.sync="rule.html" 
        :editorId="`rule-editor-${index}`"
        :rules="validationRules.html"
        :tagPlugins="tagPlugins"
        toolbar= "DynamicContentEditor"
        ></ck-editor>
        <br/>
        <content-feed-preview
          :contentFeedId="rule.ruleContentFeedId" 
          :htmlPart="rule.html"
          
          :title="'Content Preview'"
        >
        </content-feed-preview>
      </v-col>
    </v-row>
      <v-btn
        text
        class="mt-4"
        absolute
        v-track="'dynamic-content-add-new-rule'"
        @click="addNewRule()"
      >
        <v-icon class="ml-n2">mdi-plus</v-icon>
        <span class="body-2 font-weight-bold">Add New Rule</span>
      </v-btn>
  </v-form>  
</template>

<script>
import CkEditor from './CkEditor.vue';
import ContentFeedPreview from "./ContentFeedPreview.vue"; 
import AutoComplete from '@/components/ui/AutoComplete.vue'
import { $contentFeeds, $segments } from "@/services";
export default {
  name: 'DynamicContentRuleList',
  components: {    
    AutoComplete,
    ContentFeedPreview,
    CkEditor,
  },
  data(){
    return {
      isFormValid: false,
      tagPlugins:'campaigntags,dynamictags,contacttags,coupontags,tabletags,othertags,productfeedtemplatestags'
    }
  },
  props:{
    rules:{
      type: Array,
      required: true,
      default:() => [
        {
          ruleSegmentId: null,
          ruleContentFeedId: null,
          html: ""
        }
      ]
    },
    validationRules:{
      type: Object,
      required: true,
      default: () =>{}
    },
  },
  computed:{
    segmentRules() {
        const rules  = [...this.rules];
        return JSON.parse(JSON.stringify(rules))
    },
    getContentFeedApiName(){
      return $contentFeeds.fetch;
    },
    getSegmentApiName(){
      return $segments.fetch;
    },
  },
  methods:{
    deleteRule(index) {
      this.rules.splice(index, 1);
    },
    addNewRule() {
      this.rules.push({
        ruleSegmentId: null,
        ruleContentFeedId: null,
        html: ""
      });
    },
  }
}
</script>